import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Brushes",
  "description": "",
  "published": "2006-08-04T00:00:00.000Z",
  "redirect_from": ["/blog/brushes/swizec/392"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I've made a wonderful discovery in photoshop. There is a panel I was totally and completely unaware of, it allows you to change the behaviour of your brush. Sure this might seem as obvious to many of you as just why the rabbit is so deep inside the hole, but to me it was unexistand.`}</p>
    <p>{`This discovery has enabled me two things, this webcomic has jumped in quality a lot yet it still retains what I like to consider a warm and fuzzy feel that was made with the pencils being left in over the computer colouring. Now the pencils are done away with yet the thing still remains nice and fluffy almost makes you want to cuddle it.`}</p>
    <p>{`Another great thing is that I am now able to get effects done quickly and effortlessly that would otherwise require hours upon hours of work and still wouldn't look very well. They would look forced and ew, now they look natural and yum.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      